import React from "react"

import { SimulationWrapperType } from "@/test-set/simulation-wrappers"
import { FormField, Switch } from "@coval/ui"

interface SimulationWrapperSelectorProps {
  value?: SimulationWrapperType | null
  onChange: (type: SimulationWrapperType | null) => void
  showCustomOption: boolean
  disabled?: boolean
}

export const SimulationWrapperSelector: React.FC<
  SimulationWrapperSelectorProps
> = ({ value, onChange, showCustomOption, disabled }) => {
  if (!showCustomOption) {
    return null
  }

  return (
    <FormField label="Custom API" className="flex items-center gap-2 space-y-0">
      {(fieldProps) => (
        <Switch
          {...fieldProps}
          disabled={disabled}
          checked={value === SimulationWrapperType.CUSTOM}
          onCheckedChange={(enabled) =>
            onChange(enabled ? SimulationWrapperType.CUSTOM : null)
          }
        />
      )}
    </FormField>
  )
}
